import { HButton } from "@highway/hwy-design-system";
import DownloadIcon from "@mui/icons-material/Download";
import { Theme } from "@mui/material";
import ReactDOMServer from "react-dom/server";

const insertDownloadButtons = (htmlString: string, theme: Theme): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const images = doc.querySelectorAll("img");

    images.forEach((img, index) => {
        const buttonId = `download-btn-${index}`;
        const buttonHtml = ReactDOMServer.renderToString(
            <a href={img.src} className="download-image-button" download>
                <HButton
                    id={buttonId}
                    style={{
                        position: "absolute",
                        backgroundColor: theme.palette.primaryPurple.main,
                        color: theme.palette.primaryWhite.main,
                        width: "40px",
                        height: "40px",
                        padding: 0,
                        bottom: "14px",
                        right: "8px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        zIndex: 1,
                    }}
                >
                    <DownloadIcon />
                </HButton>
            </a>,
        );

        const container = document.createElement("div");
        container.style.position = "relative";
        container.style.display = "inline-block";
        img.parentNode?.insertBefore(container, img);
        container.appendChild(img);
        const buttonContainer = document.createElement("div");
        buttonContainer.innerHTML = buttonHtml;
        container.appendChild(buttonContainer.firstChild as Node);
    });

    return doc.body.innerHTML;
};

export default insertDownloadButtons;
